import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import Wallet from "../shared/wallet/Wallet";
import { SpinningCircles } from "react-loading-icons";
import {Link} from "react-router-dom";

function Story() {
  const [stories, addStories] = useState([]);

  useEffect(() => {
    const loadStories = async () => {
      try {
        const res = await axios.get(
          "https://floating-dusk-30317.herokuapp.com/api/v1/stories/getAllStories"
        );
        const stories = res.data.stories;
        addStories(stories);
      } catch (error) {
        console.log(error);
        alert("Server error");
      }
    };

    loadStories();
  }, []);

  return (
    <div>
      <Navbar />
      <div className="flex flex-row  justify-between">
        <Sidebar />

        <div className="m-4 w-[50rem]">
          <h2 className="mb-4 text-2xl text-left font-alata">
            Minerpets World &gt; Main Story &gt; Part I
          </h2>

          {stories ? (
            stories.map((story) => {
              return (
                <Link to={`/story/${story._id}`}>
                <div
                  key={story._id}
                  className="px-8 py-8 mb-4 cursor-pointer text-left bg-[#f5f5f5]"
                >
                  {story.content}
                </div>
                </Link>
              );
            })
          ) : (
            <div className="flex justify-center items-center w-full h-96">
              <SpinningCircles fill="#000" />
            </div>
          )}
        </div>

        <div className="m-4">
          
          <Wallet />
        </div>
      </div>
    </div>
  );
}

export default Story;
